import Vue from 'vue';
import "./components";
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-vue-component]').forEach((el) => {
    const data = {};

    for (let attr of el.attributes) {
      const name = attr.name;

      try {
        data[name] = JSON.parse(attr.value);
      } catch (err) {
        data[name] = attr.value;
      }
    }
    delete data.dataVueComponent;
    const componentName = el.getAttribute('data-vue-component');

    import(`./components/${componentName}.vue`).then((module) => {
      const Constructor = Vue.extend(module.default);

      const instance = new Constructor({
        propsData: data,
      });

      instance.$mount();

      el.replaceWith(instance.$el);
    }).catch((err) => {
      console.error(`Unable to mount component ${componentName}: ${err.toString()}`);
    });
  });
});
